"use strict";

var _defineProperty = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var R = __importStar(require("ramda"));

var constants_1 = require("../constants");

var selectors_1 = require("../selectors");

var verifiers_1 = require("../verifiers");

var formatFieldDataForMutation_1 = require("./formatFieldDataForMutation");

var omitDeep_1 = require("./omitDeep");

var errors_1 = require("../errors");

var DEFAULT_OPTIONS = {
  ignoreNonTableFields: true
};

var shouldPreserveMetaField = function shouldPreserveMetaField(_ref) {
  var type = _ref.type,
      fieldName = _ref.fieldName;
  return type !== constants_1.MUTATION_TYPE.UPDATE ? false : constants_1.UPDATE_META_FIELDS_TO_PRESERVE[fieldName];
};

var isFieldRemoved = function isFieldRemoved(_ref2) {
  var initialValue = _ref2.initialValue,
      value = _ref2.value;
  return !R.isNil(initialValue) && R.isNil(value);
};
/**
 * Formats entity data for create or update mutation based on passed schema.
 * @param {MutationType} type - The type of the mutation.
 * @param {string} tableName - The name of the table from the 8base API.
 * @param {Object} data - The entity data for format.
 * @param {Object} initialData - Initial data. Used in UPDATE on submit formatting to disconnect removed relations.
 * @param {Schema} schema - The schema of the used tables from the 8base API.
 */


var formatDataForMutation = function formatDataForMutation(type, data, _ref3) {
  var tableName = _ref3.tableName,
      appName = _ref3.appName,
      schema = _ref3.schema,
      initialData = _ref3.initialData;
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (R.not(type in constants_1.MUTATION_TYPE)) {
    throw new errors_1.SDKError(errors_1.ERROR_CODES.INVALID_ARGUMENT, errors_1.PACKAGES.UTILS, "Invalid mutation type: ".concat(type));
  }

  if (R.isNil(data)) {
    return data;
  }

  var tableSchema = selectors_1.tablesListSelectors.getTableByName(schema, tableName, appName);

  if (!tableSchema) {
    throw new errors_1.SDKError(errors_1.ERROR_CODES.TABLE_NOT_FOUND, errors_1.PACKAGES.UTILS, "Table schema with ".concat(tableName, " name not found in schema."));
  }

  options = R.mergeDeepRight(DEFAULT_OPTIONS, options);
  var dataKeys = R.pipe(R.mergeRight(data), R.keys)(initialData);
  var formatedData = R.reduce(function (result, fieldName) {
    if (fieldName === '_description' || fieldName === '__typename' || verifiers_1.isFilesTable(tableSchema) && !constants_1.MUTATION_FILE_FIELDS.includes(fieldName)) {
      return result;
    }

    var fieldSchema = selectors_1.tableSelectors.getFieldByName(tableSchema, fieldName);
    var _options = options,
        skip = _options.skip,
        mutate = _options.mutate,
        ignoreNonTableFields = _options.ignoreNonTableFields;

    if (!fieldSchema) {
      if (ignoreNonTableFields) {
        return result;
      }

      return Object.assign({}, result, _defineProperty({}, fieldName, data[fieldName]));
    }

    if (typeof skip === 'function' && skip(data[fieldName], fieldSchema)) {
      return result;
    }

    if (fieldSchema.fieldType !== constants_1.FIELD_TYPE.ID && !R.pathOr(true, ['dataFeatures', type.toLowerCase()], fieldSchema)) {
      return result;
    }

    if (verifiers_1.isMetaField(fieldSchema) && !shouldPreserveMetaField({
      type: type,
      fieldName: fieldName
    })) {
      return result;
    }

    var initialFieldData = R.path([fieldName], initialData);
    var formatedFieldData = isFieldRemoved({
      initialValue: initialFieldData,
      value: data[fieldName]
    }) ? null : data[fieldName];

    if ((verifiers_1.isFileField(fieldSchema) || verifiers_1.isRelationField(fieldSchema)) && verifiers_1.isListField(fieldSchema)) {
      if (R.isNil(formatedFieldData)) {
        formatedFieldData = [];
      } else {
        formatedFieldData = R.reject(R.isNil, formatedFieldData);
      }

      if (formatedFieldData.length === 0 && type === constants_1.MUTATION_TYPE.CREATE) {
        return result;
      }
    }

    formatedFieldData = formatFieldDataForMutation_1.formatFieldDataForMutation(type, formatedFieldData, {
      fieldSchema: fieldSchema,
      schema: schema,
      initialData: initialFieldData
    }, options);

    if (typeof mutate === 'function') {
      formatedFieldData = mutate(formatedFieldData, data[fieldName], fieldSchema);
    }

    if (typeof formatedFieldData === 'string' && formatedFieldData === initialFieldData) {
      return result;
    } // TODO: need to discuss with core team how to handle case when filed `isList` and have `Default Value`
    // if (Array.isArray(formatedFieldData) && R.equals(formatedFieldData, initialFieldData)) {
    //   return result;
    // }


    return Object.assign({}, result, _defineProperty({}, fieldName, formatedFieldData));
  }, {}, dataKeys);
  return omitDeep_1.omitDeep(['_description', '__typename'], formatedData);
};

exports.formatDataForMutation = formatDataForMutation;